import { render, staticRenderFns } from "./EditPreferredDeliveryAddress.vue?vue&type=template&id=a6517f46"
import script from "./EditPreferredDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./EditPreferredDeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditPreferredDeliveryAddress.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6517f46')) {
      api.createRecord('a6517f46', component.options)
    } else {
      api.reload('a6517f46', component.options)
    }
    module.hot.accept("./EditPreferredDeliveryAddress.vue?vue&type=template&id=a6517f46", function () {
      api.rerender('a6517f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditPreferredDeliveryAddress.vue"
export default component.exports